import React from 'react';
import TableComponent from '../components/common/TableComponent';

// Data user (bisa dipindahkan ke API/database nanti)
const USERS_DATA = [
    { id: "U-1023", name: "Sarah Connor", role: "Admin", email: "sarah@cloudnine.com", lastLogin: "2 mins ago" },
    { id: "U-1024", name: "Kyle Reese", role: "Editor", email: "kyle@cloudnine.com", lastLogin: "1 day ago" },
    { id: "U-1025", name: "T-800", role: "Viewer", email: "arnold@skynet.net", lastLogin: "Offline" },
];

// Kolom tabel
const COLUMNS = ["User ID", "Full Name", "Role", "Email", "Last Login"];

/**
 * Konten halaman Master User dengan tabel data user
 * @param {boolean} isDarkMode - Status dark mode
 */
const MasterUserContent = ({ isDarkMode }) => {
    return (
        <TableComponent
            title="Master User Directory"
            columns={COLUMNS}
            data={USERS_DATA}
            isDarkMode={isDarkMode}
        />
    );
};

export default MasterUserContent;
